const isDisableSttManual = (formType: any) => {
  return formType !== "manual";
};
export default isDisableSttManual;
